// extracted by mini-css-extract-plugin
module.exports = {"content":"About_content__3clsp","spinner":"About_spinner__E5tpJ","aboutImage":"About_aboutImage__2yxqO"};